module.exports = function() {
  return new Worker(__webpack_public_path__ + "2c1e826fb64cb64fba3b.worker.js");
};